import { hideOnClickOutside } from '../utils/utils';

export default class Dropdown {
	constructor(el) {
		// TURNING THIS INTO AN ARRAY ENABLES US TO INDEX THROUGH IT
		this.dropdown	= el
		this.trigger	= el.querySelector('.dropdown__select-trigger')
		this.options	= el.querySelectorAll('.dropdown__option')
		this.close		= el.querySelector('.dropdown__options .btn')

		this.toggleDropdown = this.toggleDropdown.bind(this)
		this.selectOption = this.selectOption.bind(this)

	}
  
	init() {	
		// LISTEN FOR CLICKS ON EACH ACCORDION ELEMENT
		this.trigger.addEventListener('click', this.toggleDropdown )
		this.close && this.close.addEventListener('click', this.toggleDropdown )

		for (const option of this.options) {
			option.addEventListener("click", this.selectOption)
		}
	}

	toggleDropdown() {

		this.dropdown.classList.toggle('dropdown--open')

		document.body.classList.toggle('no-scroll')

		window.app.smoothScroll.lenis && window.app.smoothScroll.lenis.isStopped ? window.app.smoothScroll.lenis.start() : window.app.smoothScroll.lenis.stop()

		if( this.dropdown.id !== 'sub-nav' ){
			hideOnClickOutside( this.dropdown, 'no-scroll', 'dropdown--open' )
		}

	}

	selectOption(event) {
		let selectedValue = event.target.innerText;
		let dropdownOptions = event.target.offsetParent.querySelectorAll('.dropdown__option');
		event.target.offsetParent.offsetParent.querySelector('.dropdown__select-trigger span:first-of-type').innerHTML = selectedValue;

		dropdownOptions.forEach((dropdownOption) => {
			dropdownOption.classList.remove('active');
		});

		event.target.classList.add('active');
		this.dropdown.classList.remove('dropdown--open')
	}
  
	unmount() {
		this.dropdown.removeEventListener('click', this.toggleDropdown )
		for (const option of this.options) {
			option.removeEventListener("click", this.selectOption)
		}
	}
}
